// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"ad917f60ac599913","912":"0804314197834e03"}[chunkId] + ".css";
};